var indexOf = [].indexOf;

import underscored from 'underscore.string/underscored';

angular.module('gym.contacts').controller('DeleteLinkedMembershipsCtrl', ["$scope", "$rootScope", "$modalInstance", "$http", "$q", "membership", "contact", "displayBrivoDeleteWarning", function($scope, $rootScope, $modalInstance, $http, $q, membership, contact, displayBrivoDeleteWarning) {
  var gym;
  gym = $rootScope.gym;
  $scope.membership = membership;
  $scope.displayBrivoDeleteWarning = displayBrivoDeleteWarning;
  $scope.relatedMembershipsLength = _.size(membership.related_family_memberships);
  $scope.selectedRelatedMemberships = _.keys(membership.related_family_memberships);
  $scope.isMembershipSelected = function(id) {
    return indexOf.call($scope.selectedRelatedMemberships, id) >= 0;
  };
  $scope.toggleMembership = function(id) {
    if ($scope.isMembershipSelected(id)) {
      return $scope.selectedRelatedMemberships = _.without($scope.selectedRelatedMemberships, id);
    } else {
      return $scope.selectedRelatedMemberships.push(id);
    }
  };
  $scope.submit = function() {
    var deletableMembershipUrls, self;
    self = `/gyms/${gym.id}/${contact.type}s/${contact.id}/memberships/${membership.id}`;
    deletableMembershipUrls = [self];
    $scope.selectedRelatedMemberships.forEach(function(membershipId) {
      var url;
      contact = membership.related_family_memberships[membershipId];
      url = `/gyms/${gym.id}/${underscored(contact.contact_type)}s/${contact.contact_id}/memberships/${membershipId}`;
      return deletableMembershipUrls.push(url);
    });
    return $q.all(_.map(deletableMembershipUrls, function(url) {
      return $http.delete(url);
    })).then(function() {
      return $modalInstance.close();
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
